import eventProxy from '@/scripts/tools/eventProxy';
import { tips, getSkewTime } from '@/scripts/tools/utils';
import tabMessage from '@/scripts/common/tabMessage';
import oauth from './oauth';
import keyBox, { restoreKeys } from './keyBox';

let credential = {};
const user = {
  isLogin: keyBox.isLogin,
  changeLoginMethod(keyType) {
    keyBox.setKeyType(keyType);
  },
  login({ keyType }) {
    keyBox.setKeyType(keyType);
    if (keyType === 'SecretKey') {
      tabMessage.sendMessage('loginMessage', { credential, keyType, isLogin: true });
      keyBox.addKey(credential);
      keyBox.login();
      eventProxy.emit('after-login');
    } else {
      user.getCredential().then(() => {
        keyBox.login();
        tabMessage.sendMessage('loginMessage', { credential, keyType, isLogin: true });
        eventProxy.emit('after-login');
      });
    }
  },
  logout() {
    credential = null;
    if (user.isLogin()) {
      tabMessage.sendMessage('logoutMessage');
    }
    keyBox.logout();
    eventProxy.emit('after-logout');
  },
  afterLogin(callback) {
    if (keyBox.isLogin() && credential && callback) {
      callback();
    }
    eventProxy.on('after-login', () => {
      if (callback) callback();
    });
  },
  afterLogout(callback) {
    if (!credential) callback();
    eventProxy.on('after-logout', () => {
      if (callback) callback();
    });
  },
  setCredential(cred) {
    credential = cred;
  },
  async getCredential(force) {
    const keyType = keyBox.getKeyType();
    if (keyType === 'QcloudAccount') {
      if (!credential) {
        user.logout();
        return {};
      }
      const {
        clientId, clientToken, userOpenId, expiredTime,
      } = credential;
      // 强制取新的临时密钥 || 第一次获取临时密钥 || 临时密钥还有 5 分钟失效
      if (force || !expiredTime || expiredTime - getSkewTime() / 1000 < 5 * 60) {
        const params = { clientId, clientToken, userOpenId };
        const res = await oauth.getCredential(params);
        const { credentials, token, expiredTime: expired } = res;

        if (!credentials || !expired) {
          user.logout();
          // TODO: 中英文翻译
          tips.error('登录态已过期，请重新登录。');
          return {};
        }

        credential = {
          ...credential,
          ...credentials,
          ...token,
          expiredTime: expired,
        };

        keyBox.setLastSession(credential);
        keyBox.triggerRememberKeys();

        return credential;
      }
      return credential;
    }

    // when (keyType === 'SecretKey')
    return credential || {};
  },
};

eventProxy.on('command.logout', user.logout);

restoreKeys().then(() => {
  keyBox.getLastSession().then(session => {
    credential = session;
    if (user.isLogin()) {
      if (!session || !(session.SecretKey || session.tmpSecretKey)) {
        user.logout();
      } else {
        eventProxy.emit('after-login');
      }
    } else {
      credential = null;
      keyBox.logout();
    }
  });
});

// 打开新窗口
tabMessage.sendMessage('newTab', 'newTab');
// 监听多窗口的通信
tabMessage.getMessage((key, newValue) => {
  if (key === 'loginMessage') {
    const { isLogin, keyType, credential: _credential } = newValue;
    if (!user.isLogin()) {
      if (isLogin) {
        user.setCredential(_credential);
        keyBox.setLastSession(_credential);
        keyBox.triggerRememberKeys();
        // setTimeout(() => {
        user.login({ keyType });
        // }, 100);
      } else {
        user.logout();
      }
    }
  } else if (key === 'logoutMessage') {
    if (user.isLogin()) {
      user.logout();
    }
  } else if (key === 'newTab') {
    // 若有新窗口打开
    // 有窗口处于登录态
    if (user.isLogin()) {
      tabMessage.sendMessage('loginMessage', { credential, keyType: keyBox.getKeyType(), isLogin: true });
    }
  }
});

export default user;
